import React from "react";

const Tooltip = ({ children, content, className }) => (
  <div className={`relative group inline-block ${className || ""}`}>
    {children}
    {/* Tooltip appears below the element */}
    <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-[9999] shadow-xl">
      {content}
      {/* Arrow pointing up */}
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-gray-900"></div>
    </div>
  </div>
);

export default Tooltip;

